import React from 'react'

const DotDivider = () => {
  return (
    <div className="dot-divider" style={{width:'100%', borderTop:'dashed 2px black', margin:'2em 0'}}></div>
  )
}

export default DotDivider